import React, { useEffect, useState } from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { FiRefreshCcw } from 'react-icons/fi';
import { ImSpinner2 } from 'react-icons/im';
import * as applicationUser from '../../../configurations/crud/applicationUserCrud';
import { MdErrorOutline } from 'react-icons/md';
import { useToast } from '../../controls/Toast/ToastService'
import useGlobalLoader from '../../../configurations/useGlobalLoader';


export default function Getbalance() {
  const { start, end } = useGlobalLoader()
  const [available, setAvailable] = useState(0);
  const [loading, setLoading] = useState(true);
  const toast = useToast()


  useEffect(() => {
    getbalance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getbalance = () => {
    setLoading(true);
    start()
    applicationUser.Getbalance()
      .then(res => {
        const mdata = res.data;
        if (mdata.result.succeeded) {
          setAvailable(mdata);
        } else {
          setAvailable([]);
        }
        setLoading(false);
        end()
      })
      .catch(errors => {
        setAvailable([]);
        setLoading(false);
        end()
        toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
      });
  };

  return (
    <div className="mb-4">
      <div className="rounded-2xl border border-gray-200 bg-white p-3 shadow-sm transition hover:shadow-md">
        <div className="flex items-center justify-between gap-3">

          <div className="flex flex-wrap items-center gap-2 text-xs sm:text-sm">
            <span className="inline-flex items-center gap-1.5 font-semibold text-gray-700">
              <FaArrowRight className="text-xs text-blue-500" /> Balance
            </span>

            {loading ? (
              <ImSpinner2 className="animate-spin text-lg text-green-600" />
            ) : (
              <div className="flex flex-wrap items-center gap-2">
                <span className="inline-flex items-center gap-1 rounded-lg bg-green-50 px-2.5 py-1 text-xs font-semibold text-green-700 ring-1 ring-green-100">
                  <span className="text-base font-bold">{available.opdBalance}</span> OPD available
                </span>
                <span className="inline-flex items-center gap-1 rounded-lg bg-gray-50 px-2.5 py-1 text-xs font-medium text-gray-600 ring-1 ring-gray-100">
                  <span className="font-bold text-gray-800">{available.opdUsedBalance}</span> OPD used
                </span>
              </div>
            )}
          </div>

          <button
            title="Refresh"
            onClick={getbalance}
            className="grid h-8 w-8 shrink-0 place-items-center rounded-lg text-green-700 transition hover:bg-gray-100 active:scale-95"
          >
            <FiRefreshCcw className={loading ? "animate-spin" : ""} />
          </button>
        </div>
      </div>
    </div>
  );
}